import { gql } from '@apollo/client';
import { Form, Input } from 'antd';
import Modal from 'components/Modal';
import { useMutation } from 'hooks/apollo';
import React, { useEffect } from 'react';

const RENAME_THEME = gql`
  mutation($id: ID!, $text: String!) {
    renameTheme(id: $id, text: $text) {
      id
      text
    }
  }
`;

const RenameTag = ({ tag, onDone, onCancel }) => {
  const [form] = Form.useForm();
  const [renameTheme, { loading }] = useMutation(RENAME_THEME);

  useEffect(() => {
    if (tag) {
      form.setFieldsValue({ name: tag?.text });
    }
  }, [tag]);

  const onSubmit = async (values) => {
    await renameTheme({ variables: { id: tag.id, text: values.name } });
    onDone();
  };

  return (
    <Modal
      title="Rename tag"
      open={!!tag}
      onCancel={onCancel}
      onOk={() => form.submit()}
      destroyOnClose
      confirmLoading={loading}
    >
      <Form form={form} onFinish={onSubmit} layout="vertical">
        <Form.Item
          label="New name"
          name="name"
          rules={[{ required: true, message: 'Please enter a new name' }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RenameTag;
